import { Wrapper } from './styled'

type TitleProps = {
  children: string
}

export function Title({ children }: TitleProps) {
  return <Wrapper>{children}</Wrapper>
}
